export { default } from './RegisterUser.js';